import cookie from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import tracker from './tracker';
var isWXA = typeof wx !== 'undefined' && !!wx.setStorageSync;
var isBrowser = typeof window !== 'undefined' && !isWXA;
export var COOKIE_NAME = 'user_device_id';
export var TIMESTAMP = 'user_device_id_timestamp';
// according to https://www.cookiestatus.com ， Safari sets the cookie lifetime of HTTP response cookies to a maximum of 7 days when the server sending the response is behind a third-party IP address.
var MIN_EFFECTIVE_TIME = 1000 * 3600 * 24 * 6; // 6 天
function mathRNG() {
    var rnds = new Array(16);
    for (var i = 0, r = 0; i < 16; i++) {
        if ((i & 0x03) === 0)
            r = Math.random() * 0x100000000;
        rnds[i] = (r >>> ((i & 0x03) << 3)) & 0xff;
    }
    return rnds;
}
export function getUUID() {
    var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    var options = getRandomValues ? undefined : { rng: mathRNG };
    var uuid = uuidv4(options).replace(/-/g, '');
    tracker(uuid);
    return uuid;
}
/**
 * 获取创建 deviceId 的时间
 *
 * @export
 * @returns
 */
export function getTimestamp() {
    if (!isBrowser && !isWXA)
        return null;
    var time;
    if (isBrowser) {
        time = cookie.get(TIMESTAMP);
    }
    else if (isWXA) {
        try {
            time = wx.getStorageSync(TIMESTAMP);
        }
        catch (e) {
            // ignore error
        }
    }
    if (time) {
        return +time;
    }
    return null;
}
export function setUserDeviceId(value, fromOldId) {
    if (fromOldId === void 0) { fromOldId = false; }
    if (isBrowser) {
        var names = window.location.hostname.split('.');
        var hostnames = names.slice(-1);
        names = names.slice(0, -1);
        var isSuccess = false;
        var domain = window.location.hostname;
        while (names.length) {
            hostnames.unshift(names.pop());
            var d = (names.length ? '.' : '') + hostnames.join('.');
            cookie.set(COOKIE_NAME, value, {
                expires: 365 * 3,
                domain: d,
                sameSite: 'None',
                // 处理在 iframe 下因为安全策略导致无法正常读取cookie
                secure: true,
            });
            if (cookie.get(COOKIE_NAME)) {
                isSuccess = true;
                domain = d;
                break;
            }
        }
        if (!isSuccess) {
            cookie.set(COOKIE_NAME, value, {
                domain: domain,
                sameSite: 'None',
                // 处理在 iframe 下因为安全策略导致无法正常读取cookie
                secure: true,
            });
        }
        if (!fromOldId) {
            cookie.set(TIMESTAMP, Date.now() + '', {
                domain: domain,
                sameSite: 'None',
                // 处理在 iframe 下因为安全策略导致无法正常读取cookie
                secure: true,
                expires: 365 * 3,
            });
        }
        window.localStorage.setItem(COOKIE_NAME, value);
        return value;
    }
    if (isWXA) {
        try {
            var now = Date.now() + '';
            // patch: 同步方法设置之后，虽然 wx.getStorageSync 可以取到值，但是 Storage 没有，用异步再次设置一遍
            wx.setStorageSync(COOKIE_NAME, value);
            wx.setStorageSync(TIMESTAMP, now);
            wx.setStorage({
                key: COOKIE_NAME,
                data: value,
            });
            wx.setStorage({
                key: TIMESTAMP,
                data: now,
            });
            return value;
        }
        catch (e) {
            // ignore error
        }
    }
    return value;
}
/**
 *判断是否有用户凭证
 *
 * @export
 * @returns
 */
export function hasUserDeviceId() {
    if (isBrowser) {
        var token = cookie.get(COOKIE_NAME);
        if (token)
            return true;
        // TODO: 兼容以前逻辑
        if (!token) {
            try {
                var item = window.localStorage.getItem('gaodingx-cache');
                if (item) {
                    var cache = JSON.parse(item);
                    if (cache && cache.data.guest_finger && cache.data.guest_finger.data) {
                        return true;
                    }
                }
                item = window.localStorage.getItem('guest_finger');
                if (item) {
                    return true;
                }
            }
            catch (error) { }
        }
    }
    if (isWXA) {
        try {
            var token = wx.getStorageSync(COOKIE_NAME);
            if (token)
                return true;
        }
        catch (error) {
            // ignore error
        }
    }
    return false;
}
/**
 * 获取用户唯一凭证， 如果没有会生成一个
 *
 * @export
 * @returns
 */
export function getUserDeviceId() {
    if (isBrowser) {
        var token = cookie.get(COOKIE_NAME);
        // TODO: 兼容以前逻辑
        if (!token) {
            try {
                var item = window.localStorage.getItem('gaodingx-cache');
                if (item) {
                    var cache = JSON.parse(item);
                    if (cache && cache.data.guest_finger && cache.data.guest_finger.data) {
                        token = cache.data.guest_finger.data;
                        setUserDeviceId(token, true);
                        return token;
                    }
                }
                item = window.localStorage.getItem('guest_finger');
                if (item) {
                    setUserDeviceId(JSON.parse(item), true);
                    return item;
                }
                item = window.localStorage.getItem(COOKIE_NAME);
                if (item) {
                    setUserDeviceId(item, true);
                    return item;
                }
            }
            catch (error) { }
        }
        if (token) {
            var timestamp = cookie.get(TIMESTAMP);
            if (Date.now() - Number(timestamp) > MIN_EFFECTIVE_TIME) {
                setUserDeviceId(token);
            }
            return token;
        }
    }
    if (isWXA) {
        try {
            var token = wx.getStorageSync(COOKIE_NAME);
            if (token)
                return token;
        }
        catch (error) {
            // ignore error
        }
    }
    return setUserDeviceId(getUUID());
}
